import React from 'react'
import './EmployeeHeader.css'
import { Button, Dropdown, Menu } from 'antd';
import { FaAngleDown } from "react-icons/fa6";
function EmployeeHeader({setEmpClick,empClick}) {
    const handleEmpteam = (emp) => {
        setEmpClick(emp)
        const savedState = JSON.parse(sessionStorage.getItem("dashboardState")) || {};
        const stateToSave = {
            attendance:savedState.attendance,
            salesDepartmentId:savedState.salesDepartmentId,
            currentStaffId:savedState.currentStaffId,
            click : savedState.click,
            empClick:emp,
            sales:savedState.sales,
            currentStaff:savedState.currentStaff ,
            active:savedState.active ,

          };
          sessionStorage.setItem("dashboardState", JSON.stringify(stateToSave));
         
    }
    const vvx: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <a className='atten-menu' onClick={() => handleEmpteam('currentstaff')}>
                    All Current staff
                </a>
            ),
        },
        {
            key: '2',
            label: (
                <a className='atten-menu' onClick={() => handleEmpteam('deactivated')}>
                    Deactivate staff
                </a>
            ),
        },
    ];
    const items: MenuProps['items'] = [
        {
            key: '1',
            label: (
                <a className='hed-menu' onClick={() => handleEmpteam('addstaff')}>
                    Add staff
                </a>
            ),
        },
        {
            key: '2',
            label: (
                <a className='hed-menu' onClick={() => handleEmpteam('editstaff')}>
                    Edit staff info
                </a>
            ),
        },
    ];
    return (
        <div>
            <div className='flex !mt-2 !mb-5'>
                <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !px-5 min-w-[125px] font-ProximaBold outline-none focus:outline-none' style={{backgroundColor: `${empClick === 'empteamadmin' ? '#4B8AEB' : '#E4EEFC'}`,color: `${empClick === 'empteamadmin' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}} onClick={() => handleEmpteam('empteamadmin')}>Emp. Team (Admin)</Button>
                {/* <Button className='hed-button ml-3' >Org. Details(Admin)</Button>
                <Button className='hed-button ml-3' >Overview</Button> */}
                <Dropdown overlay={<Menu items={vvx} />} placement="bottomLeft">
                    <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !pl-5 !pr-4 min-w-[125px] font-ProximaBold !ml-3 outline-none focus:outline-none flex items-center justify-center' style={{backgroundColor: `${empClick === 'currentstaff' || empClick === 'deactivated' ? '#4B8AEB' : '#E4EEFC'}`,color: `${empClick === 'currentstaff' || empClick === 'deactivated' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}}><div className='flex items-center leading-none flex-col'>Staff Directory
                    {(empClick === 'currentstaff' || empClick === 'deactivated') && (<small className='block text-[rgba(255,255,255,.7)] text-[11px] leading-none mt-1'>{empClick === 'currentstaff' ? 'All Current Staff' : 'Deactivated Staff'}</small>
                    )}</div><FaAngleDown className='ml-2 text-xs' /></Button>
                </Dropdown>
                <Dropdown overlay={<Menu items={items} />} placement="bottomLeft">
                    <Button className='bg-[#4B8AEB] rounded-full h-[50px] shadow-none border-none !pl-5 !pr-4 min-w-[125px] font-ProximaBold !ml-3 outline-none focus:outline-none flex items-center justify-center' style={{backgroundColor: `${empClick === 'addstaff' || empClick === 'editstaff' ? '#4B8AEB' : '#E4EEFC'}`,color: `${empClick === 'addstaff' || empClick === 'editstaff' ? '#FFFFFF' : 'rgb(138, 163, 190)'}`}}><div className='flex items-center leading-none flex-col'>Manage
                    {(empClick === 'addstaff' || empClick === 'editstaff') && (<small className='block text-[rgba(255,255,255,.7)] text-[11px] leading-none mt-1'>{empClick === 'addstaff' ? 'Add Staff' : 'Edit Staff'}</small>
                    )}</div><FaAngleDown className='ml-2 text-xs' /></Button>
                </Dropdown>

            </div>
        </div>
    )
}

export default EmployeeHeader